import React, { useState } from 'react';
import PropTypes from 'prop-types';

import GridRadioButton from '../ui/radioButton/GridRadioButton';

const RenderGridRadioButtonColumn = ({ rowData, col, rowIndex, onColumnDataChange }) => {

    const [selectedOption, setSelectedOption] = useState(rowData[col.fieldName]);
    const { fieldName } = col;

    /**
    * Handles change in dropdown selection.
    * @param {object|string} selectedValue - The selected option.
    */
    const handleOnChange = (selectedValue) => {
        setSelectedOption(selectedValue);

        if (onColumnDataChange) {
            const newRowData = { ...rowData, [fieldName]: selectedValue };
            onColumnDataChange(fieldName, newRowData, rowIndex);
        }
    };

    return (
        <GridRadioButton
            name={col.name}
            onChange={handleOnChange}
            radioId={`${fieldName}-${rowIndex}`}
            isChecked={selectedOption === rowData[fieldName]}
            valueName={selectedOption}
        />
    );
};

RenderGridRadioButtonColumn.propTypes = {
    rowData: PropTypes.object.isRequired,
    col: PropTypes.shape({
        fieldName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    rowIndex: PropTypes.number.isRequired,
    onColumnDataChange: PropTypes.func,
};

export default RenderGridRadioButtonColumn;
